import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ShallowSeaCoralReefTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_CORAL_REEF;
}

export default ShallowSeaCoralReefTerrainTileEntity;
